import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ProcessingStateService {
    private readonly processing = signal(false);

    readonly isProcessing = this.processing.asReadonly();

    setProcessing(isProcessing: boolean): void {
        this.processing.set(isProcessing);
    }
}
